import { useEffect, useState } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card.jsx';
import { Badge } from '../components/ui/badge.jsx';
import axios from "../lib/axios.js";
import { Skeleton } from "../components/ui/skeleton.jsx";
import { useToast } from '../hooks/use-toast.js';


const HealthPage = () => {
  const [healthChecks, setHealthChecks] = useState(null);
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  const { toast } = useToast();

  useEffect(() => {
    const fetchHealthChecks = async () => {
      try {
        const response = await axios.get('/health');
        setHealthChecks(response.data);
      } catch (err) {
        setError('Error fetching health checks');
        toast({
          title: "Error",
          description: "Failed to load health checks.",
          variant: "destructive",
        });
      } finally {
        setIsLoading(false);
      }
    };

    fetchHealthChecks();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (isLoading && !error) {
    return (
      <div className="min-h-full min-w-full flex flex-col">
        <Card className="w-full max-w-7xl mx-auto">
          <CardHeader>
            <CardTitle>Loading Health Status...</CardTitle>
          </CardHeader>
          <CardContent>
            <div className="space-y-4">
              {/* Use Skeleton components for loading states */}
              <Skeleton className="h-6 w-1/2" />
              <Skeleton className="h-6 w-full" />
              <Skeleton className="h-6 w-full" />
              <Skeleton className="h-6 w-1/3" />
            </div>
          </CardContent>
        </Card>
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-full min-w-full flex flex-col">
        <Card className="w-full max-w-7xl mx-auto">
          <CardHeader>
            <CardTitle>Error</CardTitle>
          </CardHeader>
          <CardContent>
            <p className="text-red-500">{error}</p>
          </CardContent>
        </Card>
      </div>
    );
  }


  return (
    <div className="min-h-full min-w-full flex flex-col">
      <Card className="w-full max-w-7xl mx-auto">
        <CardHeader>
          <CardTitle>Health Status</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="mb-4">
            <div className="text-lg font-semibold">
              Overall Status:{' '}
              <Badge
                className={`capitalize px-2 py-1 ${healthChecks.status === 'UP' ? 'bg-green-500' : 'bg-red-500'
                  }`}
              >
                {healthChecks.status}
              </Badge>
            </div>
          </div>
          <ul className="space-y-4">
            {Object.entries(healthChecks.services).map(([service, status]) => (
              <li key={service} className="flex items-center justify-between">
                <span className="text-sm font-medium text-gray-700">{service}</span>
                <Badge
                  className={`capitalize px-2 py-1 ${status === 'UP' || status === 'Connected' ? 'bg-green-500' : 'bg-red-500'
                    }`}
                >
                  {status}
                </Badge>
              </li>
            ))}
          </ul>
        </CardContent>
      </Card>
    </div>
  );
};

export default HealthPage;